module.exports = __webpack_public_path__ + "media/images/frontend/close-459e9bb02fa6df969e0ac8daa76938de.svg";